import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=c4d4d7e6&scoped=true&"
import script from "./couponList.ts?vue&type=script&lang=js&"
export * from "./couponList.ts?vue&type=script&lang=js&"
import style0 from "./couponList.less?vue&type=style&index=0&id=c4d4d7e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d4d7e6",
  null
  
)

export default component.exports